import { TextIllustrationColumnsProps } from '@/components/TextIllustrationColumns';
import { COLORS } from '@/styles/color';
import { mediaBreakpointOnly, mediaBreakpointUp, paddingX, square } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize } from '@/styles/typography/utils';
import styled from 'styled-components';

const Heading = styled.h2`
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  ${customTextSize(24, 30)}
  text-align: center;
  letter-spacing: -0.01em;
  color: ${COLORS.RED.LOWLIGHT};
  margin-bottom: 40px;

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(32, 38)}
    margin-bottom: 60px;
  }

  ${mediaBreakpointUp('desktopWide')} {
    ${customTextSize(49, 58)}
    margin-bottom: 120px;
  }
`;

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 80px 20px;

  ${mediaBreakpointUp('tablet')} {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
  }
`;

interface ColumnProps {
  center: boolean;
}

const Column = styled.div<ColumnProps>`
  ${paddingX(10)}
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 0;
  gap: 20px;
  text-align: center;

  ${mediaBreakpointOnly('tablet')} {
    flex-basis: ${(props) => (props.center ? '100%' : 0)};
  }

  ${mediaBreakpointUp('desktopWide')} {
    max-width: 25%;
  }
`;

interface ColumnIllustrationProps {
  size: TextIllustrationColumnsProps['columnIllustrationSize'];
}

const ColumnIllustration = styled.div<ColumnIllustrationProps>`
  ${(props) => {
    switch (props.size) {
      case 'large':
        return square(160);
      case 'standard':
      default:
        return square(80);
    }
  }}

  img {
    width: 100%;
  }
`;

const ColumnHeadingStandard = styled.h3`
  ${customTextSize(20, 24)}
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
`;

const ColumnHeadingSmallCaps = styled.h3`
  ${customTextSize(16, 20)}
  font-weight: ${FONT_WEIGHTS.BOLD};
  color: ${COLORS.RED.LOWLIGHT};
  text-transform: uppercase;
  letter-spacing: 0.08em;
`;

const ColumnContentStandard = styled.div`
  ${customTextSize(14, 20)}
  margin-top: -10px;
`;

const ColumnContentLargeBold = styled.div`
  ${customTextSize(20, 24)}
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
`;

const textIllustrationColumnsComponents = {
  Heading,
  Grid,
  Column,
  ColumnIllustration,
  ColumnHeadingStandard,
  ColumnHeadingSmallCaps,
  ColumnContentStandard,
  ColumnContentLargeBold,
};

export default textIllustrationColumnsComponents;
